import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const DashboardShimmer = () => (
  <>
    {/* <div className="row-fluid-scroll flex-nowrap mb-4" style={{ overflowX: 'scroll' }}>
      {[...Array(4)].map((_, idx) => (
        <div key={idx} style={{ width: '100%', marginRight: '16px' }}>
          <Skeleton height={120} style={{ marginBottom: 8 }} />
          <Skeleton height={30} width={80} />
        </div>
      ))}
    </div> */}
    <div className="row">
      <div className="col-xl-8">
        <Skeleton height={300} style={{ marginBottom: 16 }} />
      </div>
      <div className="col-xl-4">
        <Skeleton height={300} style={{ marginBottom: 16 }} />
      </div>
      <div className="col-xl-12">
        <Skeleton height={150} count={4} style={{ marginBottom: 8 }} />
      </div>
    </div>
  </>
);

export default DashboardShimmer;
